import request from '@/utils/service'

export function login(username, password) {
  const data = { loginName: username, loginPwd: password }

  return request({
    url: '/login',
    method: 'post',
    data
  })
}

export function loginByBusiness(username, password) {
  const data = { loginName: username, loginPwd: password }

  return request({
    url: '/loginByShop',
    method: 'post',
    data
  })
}

export function getUserInfo() {
  return request({ url: '/mgr/current', method: 'post', data: {} })
}

export function logout() {
  return request({
    url: '/logout',
    method: 'post',
    data: {}
  })
}

export function changePassword(data) {
  return request({
    url: '/mgr/changePwd',
    method: 'post',
    data
  })
}
